import React from 'react';
import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DoneIcon from '@mui/icons-material/Done';
import { useTranslation } from 'react-i18next';

const paymentData = {
  en: [
    '50% deposit is required to book the property.',
    'Full payment is required at check in.',
    'Deposit is non refundable if the booking is cancelled.',
    'Check in – 15:00 hrs, Check out – 11:00 hrs.',
    'Accepted payment methods:',
  ],

  el: [
    'Απαιτείται προκαταβολή 50% για την κράτηση του καταλύματος.',
    'Η πλήρης εξόφληση πραγματοποιείται κατά το check-in.',
    'Η προκαταβολή δεν επιστρέφεται σε περίπτωση ακύρωσης.',
    'Check-in – 15:00, Check-out – 11:00.',
    'Αποδεκτοί τρόποι πληρωμής:',
  ],

  de: [
    'Für die Buchung der Unterkunft ist eine Anzahlung von 50 % erforderlich.',
    'Der Gesamtbetrag ist beim Check-in zu bezahlen.',
    'Die Anzahlung ist im Falle einer Stornierung nicht erstattungsfähig.',
    'Check-in – 15:00 Uhr, Check-out – 11:00 Uhr.',
    'Akzeptierte Zahlungsmethoden:',
  ],

  fr: [
    'Un acompte de 50 % est requis pour réserver le logement.',
    'Le paiement intégral est exigé lors du check-in.',
    'L’acompte n’est pas remboursable en cas d’annulation.',
    'Check-in – 15h00, Check-out – 11h00.',
    'Modes de paiement acceptés :',
  ],

  ro: [
    'Este necesar un avans de 50% pentru a rezerva proprietatea.',
    'Plata integrală se efectuează la check-in.',
    'Avansul nu este rambursabil în cazul anulării.',
    'Check-in – 15:00, Check-out – 11:00.',
    'Metode de plată acceptate:',
  ],

  bg: [
    'Изисква се депозит от 50% за резервация на имота.',
    'Пълното плащане се извършва при настаняване.',
    'Депозитът не се възстановява при анулиране.',
    'Настаняване – 15:00, Освобождаване – 11:00.',
    'Приети методи на плащане:',
  ],

  mk: [
    'Потребен е депозит од 50% за резервација на објектот.',
    'Целосната уплата се врши при check-in.',
    'Депозитот не се враќа во случај на откажување.',
    'Check-in – 15:00, Check-out – 11:00.',
    'Прифатени начини на плаќање:',
  ],

  sr: [
    'За резервацију објекта потребан је депозит од 50%.',
    'Пуно плаћање се врши при пријави (check-in).',
    'Депозит се не враћа у случају отказивања.',
    'Check-in – 15:00, Check-out – 11:00.',
    'Прихваћени начини плаћања:',
  ],

  ru: [
    'Для бронирования объекта требуется депозит в размере 50%.',
    'Полная оплата производится при заезде.',
    'Депозит не возвращается в случае отмены бронирования.',
    'Заезд – 15:00, Выезд – 11:00.',
    'Принимаемые способы оплаты:',
  ],

  uk: [
    'Для бронювання об’єкта необхідно внести депозит у розмірі 50%.',
    'Повна оплата здійснюється під час заїзду.',
    'Депозит не повертається у разі скасування бронювання.',
    'Заїзд – 15:00, Виїзд – 11:00.',
    'Прийнятні способи оплати:',
  ],
};
const paymentDataDefault = paymentData.en;

function PaymentDetails() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];
  const paymentDataSelected = paymentData[lang] || paymentDataDefault;

  return (
    <Box mx={{ xs: 4, md: 0.5 }}>
      <Typography
        variant="h5"
        sx={{
          color: 'primary.main',
          fontWeight: 900,
          textAlign: { xs: 'center', md: 'start' },
        }}
      >
        Payment Details
      </Typography>
      <List disablePadding sx={{ lineHeight: '0.2rem' }}>
        {paymentDataSelected.map((item) => (
          <ListItem sx={{ lineHeight: '0.3rem', p: 0 }} key={item}>
            <ListItemIcon>
              <DoneIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{item}</ListItemText>
          </ListItem>
        ))}
      </List>
      <Box display="flex" justifyContent="space-between" mx={4}>
        <img
          src="/icons/visa.png"
          alt="Visa"
          width={50}
          height={50}
          loading="lazy"
          decoding="async"
          style={{ width: 50, height: 50 }}
        />
        <img
          src="/icons/mc.png"
          alt="MasterCard"
          width={50}
          height={50}
          loading="lazy"
          decoding="async"
          style={{ width: 50, height: 50 }}
        />
        <img
          src="/icons/amex.png"
          alt="American Express"
          width={50}
          height={50}
          loading="lazy"
          decoding="async"
          style={{ width: 50, height: 50 }}
        />
        <img
          src="/icons/pp.png"
          alt="PayPal"
          width={50}
          height={50}
          loading="lazy"
          decoding="async"
          style={{ width: 50, height: 50 }}
        />
      </Box>
    </Box>
  );
}

export default PaymentDetails;
